// #region COLOR MAPPING STATE
export const getPOSColorNames = colorsFromPOS =>
    [...new Set((Array.isArray(colorsFromPOS) ? colorsFromPOS : []).map(color => color?.name)
        .filter(name => typeof name === "string" && name.trim()))];

export const isPOSColorCatalogueAvailable = data =>
    !data?.colorsErrorFromPOS && getPOSColorNames(data?.colorsFromPOS).length > 0;

export function buildColorSuggestions(labelBrandColors, matches, colorsFromPOS) {
    const validNames = new Set(getPOSColorNames(colorsFromPOS));
    return (Array.isArray(labelBrandColors) ? labelBrandColors : []).flatMap(labelBrandName => {
        const match = (Array.isArray(matches) ? matches : []).find(item => item?.colorName === labelBrandName &&
            validNames.has(item.posColorName) && Number.isFinite(item.confidence) && item.confidence >= 0 && item.confidence <= 100);
        return match ? [{ labelBrandName, exportName: match.posColorName, confidence: match.confidence }] : [];
    });
}

export function mergeColorMappings(labelBrandColors, savedMappings, suggestions, colorsFromPOS) {
    if (!Array.isArray(labelBrandColors) || labelBrandColors.length === 0) {
        // Missing source data cannot authorize deleting confirmed conversions.
        const mappings = (Array.isArray(savedMappings) ? savedMappings : [])
            .filter(item => typeof item?.exportName === "string" && item.exportName.trim())
            .map(({ labelBrandName, exportName }) => ({ labelBrandName, exportName }));
        return { mappings, needConfirmation: mappings.length > 0 };
    }
    const validNames = new Set(getPOSColorNames(colorsFromPOS));
    const mappings = (Array.isArray(labelBrandColors) ? labelBrandColors : []).flatMap(labelBrandName => {
        const saved = (Array.isArray(savedMappings) ? savedMappings : []).find(item => item?.labelBrandName === labelBrandName &&
            typeof item.exportName === "string" && item.exportName.trim());
        if (saved) return [{ labelBrandName, exportName: saved.exportName,
            ...(!validNames.has(saved.exportName) && { needsReview: true }) }];
        const suggestion = (Array.isArray(suggestions) ? suggestions : []).find(item => item?.labelBrandName === labelBrandName &&
            validNames.has(item.exportName) && Number.isFinite(item.confidence) && item.confidence >= 0 && item.confidence <= 100);
        return suggestion ? [{ labelBrandName, exportName: suggestion.exportName, confidence: suggestion.confidence }] : [];
    });
    return { mappings, needConfirmation: mappings.some(item => item.needsReview || Number.isFinite(item.confidence)) };
}

export function areColorsMapped(labelBrandColors, mappings, colorsFromPOS) {
    const validNames = new Set(getPOSColorNames(colorsFromPOS));
    return Array.isArray(labelBrandColors) && labelBrandColors.length > 0 && labelBrandColors.every(name =>
        mappings.some(mapping => mapping.labelBrandName === name && validNames.has(mapping.exportName)));
}

export function getColorMappingStatus(data, mappings) {
    if (!data?.labelBrandColors?.length) return "No brand colour data is available yet.";
    if (!isPOSColorCatalogueAvailable(data))
        return "POS colours are unavailable. Please try again later.";
    if (data.labelBrandColorsMatchesError)
        return "Automatic colour suggestions are unavailable. You can still map colours manually.";
    if (!areColorsMapped(data.labelBrandColors, mappings, data.colorsFromPOS))
        return "No safe automatic suggestion is available for some colours. Please select their POS colours manually.";
    return null;
}
// #endregion
